import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/print.css';
import AppWrapper from './App';  // ✅ import AppWrapper instead of App
import reportWebVitals from './reportWebVitals';

// Dev helper: capture specific React DOM warning about non-boolean `button` attribute
// and print a stack trace so we can find which component is forwarding `button` to
// a native DOM element. This code runs only in development.
if (process.env.NODE_ENV !== 'production') {
  try {
    const _origConsoleError = console.error.bind(console);
    console.error = (...args) => {
      try {
        if (args && args[0] && typeof args[0] === 'string' && args[0].includes('Received `true` for a non-boolean attribute `button`')) {
          _origConsoleError('[dev-helper] React DOM warning detected: printing stack trace to help locate the component source');
          // Create an Error to capture a stack. It will show where console.error was called.
          const e = new Error('React non-boolean attribute `button` detected');
          _origConsoleError(e.stack);
        }
      } catch (e) {
        // swallow
      }
      _origConsoleError(...args);
    };
  } catch (e) {}
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppWrapper />   {/* ✅ render AppWrapper, not App */}
  </React.StrictMode>
);

reportWebVitals();
